import { render } from "./Confirm.vue?vue&type=template&id=28a3f9f0&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"

import "./Confirm.vue?vue&type=style&index=0&id=28a3f9f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28a3f9f0"

export default script